import api from '@/api/user';
import store from '@/store';

export default {
  set(newValues) {
    const { user } = store.state.auth;
    const customSettings = Array.isArray(user.customSettings)
      ? {}
      : JSON.parse(JSON.stringify(user.customSettings));

    Object.entries(newValues).forEach(([k, v]) => { customSettings[k] = v; });

    store.commit('auth/setUser', { ...user, customSettings });
    return api.update(store.state.auth.user.id, { customSettings });
  },
};
